module.exports = __webpack_public_path__ + "static/media/INFY.62a07e97.txt";